// axios interceptor
export default function(config) {
  if (localStorage.jwt && !config.ignoreAuth) {
    Object.assign(config.headers, {
      Authorization: `Bearer ${localStorage.jwt}`,
    })
  }

  Object.assign(config.headers, {
    'Accept-Language': localStorage.languageabrev || 'en-us',
  })

  return config
}
